var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12423_29206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.30417 18.2718L10.3708 14.2051L13.0375 16.8718L17.7708 12.1718V14.2718H20.4375V7.60514H13.7708V10.2718H15.8708L13.0375 13.1051L10.3708 10.4385L4.4375 16.4051L6.30417 18.2718ZM3.10417 24.9385C2.37084 24.9385 1.74284 24.6771 1.22017 24.1545C0.697502 23.6318 0.436613 23.0043 0.437502 22.2718V3.60515C0.437502 2.87181 0.698836 2.24381 1.2215 1.72115C1.74417 1.19848 2.37172 0.93759 3.10417 0.938479H21.7708C22.5042 0.938479 23.1322 1.19981 23.6548 1.72248C24.1775 2.24515 24.4384 2.8727 24.4375 3.60515V22.2718C24.4375 23.0051 24.1762 23.6331 23.6535 24.1558C23.1308 24.6785 22.5033 24.9394 21.7708 24.9385H3.10417Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12423_29206"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.4375,
    y: 0.938477,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.ac74d54571e8eb396421f9ee9b2af729.svg";
export { ForwardRef as ReactComponent };